module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"startTypingAddress":"Start typing the address"}}')
  delete Component.options._Ctor
}
